export class HisSearchResultConfigColumn {
    id: string;
    label: string;
    checked = true;

    constructor(id: string, label: string) {
        this.id = id;
        this.label = label;
    }
}
